module.exports = __webpack_public_path__ + "static/media/icon_list_4.93e874e7.png";